// extracted by mini-css-extract-plugin
module.exports = {"container":"note_container__3YHAx","blueVariant":"note_blueVariant__NMJFO","title":"note_title__2NUzU","content":"note_content__20weA"};